import { render } from "./month-availability.component.vue?vue&type=template&id=01b0ed2b&scoped=true&ts=true"
import script from "./month-availability.component.vue?vue&type=script&lang=ts"
export * from "./month-availability.component.vue?vue&type=script&lang=ts"

import "./month-availability.component.vue?vue&type=style&index=0&id=01b0ed2b&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b0ed2b"]])

export default __exports__